module.exports = __webpack_public_path__ + "static/Sidd-a860c5984cc86fbd79d0de2579f5e655.png";